import { render, staticRenderFns } from "./GroupRow.vue?vue&type=template&id=c672e314&scoped=true&"
import script from "./GroupRow.vue?vue&type=script&lang=ts&"
export * from "./GroupRow.vue?vue&type=script&lang=ts&"
import style0 from "./GroupRow.vue?vue&type=style&index=0&id=c672e314&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c672e314",
  null
  
)

export default component.exports